import { User, Location } from '../types/UsersFilterData';
import { Locations } from '../types/Locations';

interface LocationWithColor extends Location {
    color?: string;
}

export function extractUniqueLocationsFromUsers(
    users: User[],
    locationsApiData: Locations[] = []
): LocationWithColor[] {
    const locationMap = new Map<string, LocationWithColor>();
    
    const apiLocationMap = new Map<string, Locations>();
    locationsApiData.forEach((location) => {
        apiLocationMap.set(location._id, location);
    });
    
    users.forEach((user) => {
        if (user.location && user.location.id && user.location.name) {
            const locationId = user.location.id;
            
            if (!locationMap.has(locationId)) {
                // Find matching location in API data to get color
                const matchingApiLocation = apiLocationMap.get(locationId);
                
                locationMap.set(locationId, {
                    id: user.location.id,
                    name: user.location.name,
                    color: matchingApiLocation?.color || '#cccccc' // Default color if not found
                });
            }
        }
    });
    
    return Array.from(locationMap.values()).sort((a, b) => a.name.localeCompare(b.name));
}